import { render, staticRenderFns } from "./AutoBox.vue?vue&type=template&id=67ef2864&scoped=true&"
import script from "./AutoBox.vue?vue&type=script&lang=js&"
export * from "./AutoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef2864",
  null
  
)

export default component.exports